import React from 'react';
import DataLoader from '../../../../../../components/Common/Loader/DataLoader';
import GridLayout from '../../../../../../components/GridLayout';
import { View } from '../../../../../../components/Common/react-native-components';

const Loader = () => {
    function renderLoaderCard({ item }) {
        return <DataLoader isBordered={false} gapBetweenGrids={16} gridData={item?.data} />;
    }

    return (
        <View style={{ marginTop: 10 }}>
            <GridLayout
                gap={20}
                data={[
                    {
                        data: [
                            { height: 52, flex: 1 },
                            { height: 52, flex: 1 },
                            { height: 52, flex: 1 }
                        ]
                    }
                ]}
                renderItem={renderLoaderCard}
            />
        </View>
    );
};

export default Loader;
